var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c("teacher-class-form", {
        ref: "realForm",
        attrs: { disabled: _vm.disableSubmit, normal: "" },
        on: { ok: _vm.submitCallback },
      }),
      _c(
        "div",
        { staticClass: "drawer-footer" },
        [
          _c(
            "a-button",
            {
              staticStyle: { "margin-bottom": "0" },
              on: { click: _vm.handleCancel },
            },
            [_vm._v("关闭")]
          ),
          !_vm.disableSubmit
            ? _c(
                "a-button",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleOk },
                },
                [_vm._v("提交")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }